

























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { CheckBox } from '@/components/form'

// models
import { EmployeePlame } from '@/models/config'

@Component({
    name: 'PlameSectionForm',
    components: {
        CheckBox
    }
})
export default class PlameSectionForm extends Vue {
    @Prop({ type: Object, required: true }) plame!: EmployeePlame
}
